
<embed-video *ngIf="video; else noVideo" [accountLicense]="accountLicense" [params]="videoParams" [video]="video" (onEnded)="next()">
</embed-video>

<ng-template #noVideo>
	<vb-loading-spinner *ngIf="!error; else errorMsg" flex="fill" flex-align="center" flex-justify="center" layout="row" [size]="'large'">
	</vb-loading-spinner>
</ng-template>

<ng-template #errorMsg>
	<div class="embed-video-unavailable" flex="fill" flex-align="center" flex-justify="center" layout="column">

		<div class="embed-video-warning">
			<span class="glyphicons warning_sign"></span>
			{{ 'Media_Videos_Embed_NoLongerAvailable' | translate }}
		</div>
		<button class="btn-icon-right" type="button" (click)="next()" [hidden]="playlist?.videos.length <= 1" vbBtnPrimary>
			{{ 'Next' | translate }}
			<span class="glyphicons chevron-right"></span>
		</button>
	</div>
</ng-template>

<div [ngClass]="styles.sliderToolbar" [hidden]="!toolbarVisible">
	<span flex="fill">{{ video?.title || '' }}</span>
	<button type="button" [attr.aria-label]="'Carousel_Previous' | translate" (click)="previous()">
		<span class="glyphicons chevron-left"></span>
	</button>
	<button type="button" [attr.aria-label]="'Carousel_Next' | translate" (click)="next()">
		<span class="glyphicons chevron-right"></span>
	</button>
</div>
